export class Categoria {

public id:number;
public nombre:string;
public descripcion:string;
public codigoCategoria:string;
public codigoConsorcio:string;
public entradaTipo:string;
public entradaCosto:number;
public entradaMinimo:number;
public idFormulaEntrada:number;
public salidaTipo:string;
public salidaCosto:number;
public salidaMinimo:number;
public idFormulaSalida:number;
public almacenamientoTipo:string;
public almacenamientoCosto:number;
public almacenamientoMinimo:number;
public idFormulaAlmacenamiento:number;
public descargaTipo:string;
public descargaCosto:number;
public descargaMinimo:number;
public idFormulaDescarga:number;
public cargaTipo:string;
public cargaCosto:number;
public cargaMinimo:number;
public idFormulaCarga:number;
public alistoTipo:string;
public alistoCosto:number;
public alistoMinimo:number;
public idFormulaAlisto:number;
public movimientoTipo:string;
public movimientoCosto:number;
public movimientoMinimo:number;
public idFormulaMovimiento:number;
public seguroTipo:string;
public seguroCosto:number;
public seguroMinimo:number;
public idFormulaSeguro:number;

}



// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/model/categoria.ts